function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  }
  const domain = location.hostname == "localhost" ? "" : ";domain=." + location.hostname.split('.').reverse()[1] + "." + location.hostname.split('.').reverse()[0];
  const security = location.hostname == "localhost" ? "" : ";SameSite=None; Secure";
  document.cookie = name + "=" + value + expires + ";path=/" + domain + security;
}
if (getQueryString("modal") !== null) {
  setCookie("modal", getQueryString("modal"));
}
$(document).ready(function() {
  var lgr = readCookie("lgr");
  var modal = readCookie("modal");
  var welcomeModalClosed = readCookie("welcomeModalClosed");
  if (lgr == "0f4ce4f7-9e5a-472f-b918-da6ed55a9264" && modal == "welcome") {
    $("#welcome-banner").show();
    if (!welcomeModalClosed) {
      $('#offer-modal').modal('show');
      $('#offer-modal').on('hidden.bs.modal', function (e) {
        setCookie("welcomeModalClosed", true)
      })
    }
  }
});